import { apiClientAuth } from "../http/httpClient";


export function OrderApi(contentType = "application/json")
{
    const https = apiClientAuth(contentType);

    return {

       /**
        * @route   GET /api/orders
        * @desc    Récupérer toutes les commandes avec utilisateurs et produits
        * @access  Private (Authentifié)
        */
        findAll : () => https.get(`/api/orders`),

       /**
        * @route   GET /api/orders/count/status
        * @desc    Compter le nombre de commandes par statut (pending, delivered, canceled)
        * @access  Private (Authentifié)
        * @note    Cette route doit être placée AVANT la route /status/:status pour éviter les conflits
        */
        getCountByStatus : () => https.get(`/api/orders/count/status`),

       /**
        * @route   GET /api/orders/count/year
        * @desc    Compter le nombre de commandes par mois pour l'année en cours
        * @access  Private (Authentifié)
        * @note    Cette route doit être placée AVANT la route /status/:status pour éviter les conflits
        */
        getStatOfYear : () => https.get(`/api/orders/count/year`),

       /**
        * @route   GET /api/orders/total-amount/years
        * @desc    Récupérer le montant total annuel des commandes pour les 6 dernières années
        * @access  Private (Admin)
        * @note    Cette route doit être placée AVANT la route /status/:status pour éviter les conflits
        * @returns {Object} Array de données annuelles:
        *   - year: année
        *   - totalAmount: montant total des commandes pour cette année
        *   - grandTotal: total global sur la période
        */
        getStatOfYears : () => https.get(`/api/orders/total-amount/years`),

       /**
        * @route   GET /api/orders/status/:status
        * @desc    Récupérer toutes les commandes selon le statut spécifié
        * @access  Private (Authentifié)
        * @param   {string} status - Statut de la commande (pending, delivered, canceled)
        * @middleware validateStatusParam - Valide le paramètre statut
        * @middleware handleValidationErrors - Gère les erreurs de validation
        */
        findAllBystatus : (orderStatus) => https.get(`/api/orders/status/${orderStatus}`),

       /**
        * @route   PUT /api/orders/:id/status
        * @desc    Mettre à jour le statut d'une commande
        * @access  Private (Authentifié)
        * @param   {integer} id - Identifiant de la commande
        * @body    {string} status - Nouveau statut (pending, delivered, canceled)
        * @body    {string} [adminEmail] - Email du modérateur (requis si status = delivered)
        * @middleware validateOrderId - Valide le paramètre ID
        * @middleware validateUpdateStatus - Valide les données de la mise à jour
        * @middleware handleValidationErrors - Gère les erreurs de validation
        */
        update: (id, orderStatus) => https.put(`/api/orders/${id}/status`, orderStatus),

       /**
        * @route   GET /api/orders/:id
        * @desc    Récupérer une commande spécifique avec tous les produits et leurs images
        * @access  Private (Authentifié)
        * @param   {integer} id - Identifiant de la commande
        * @middleware validateOrderId - Valide le paramètre ID
        * @middleware handleValidationErrors - Gère les erreurs de validation
        */
        findOne: (id) => https.get(`/api/orders/${id}`),


    };
}

